import { find, pipe, propEq, propOr } from 'ramda'
import { Policy, Benefit, BenefitInfo } from './types'

/**
 * V2 version of getBenefit() util function Extract either a benefit or
 * benefit.limitValue from a policy, considering showBenefit flag
 *
 * @param {object} policy - A policy a member with benefitInfo property
 * @param {string} benefitType - The actual name of the benefit. i.e. DEDUCTIBLE
 * @param {boolean} [considerShowBenefit=true] - Primarily for LDFlag-whether to
 *   filter based on showBenefit flag. When true, use new showBenefit
 *   properties. Default is `true`
 */
export const getBenefitData = (
  policy: Policy = {},
  benefitType = '',
  considerShowBenefit = true,
): Benefit | undefined => {
  // Find the current benefit info or default to an empty array.
  const benefitInfo = pipe(
    propOr([] as BenefitInfo[], 'benefitInfo'),
    find(propEq('current', true)),
  )(policy)

  // If no current benefit info is found, return undefined
  if (!benefitInfo) return undefined

  // Default benefits to an empty array if not present.
  const benefits: Benefit[] = propOr([] as Benefit[], 'benefits', benefitInfo)

  // Now safely apply filter, as we know benefits is always an array.
  const visibleBenefit = benefits.filter(
    b => !considerShowBenefit || b.showBenefit,
  )

  // Return the benefit matching the benefitType.
  return visibleBenefit.find(propEq('benefitType', benefitType))
}
